.presets {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.preset {
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  border: solid 1px var(--pinkish-grey);
  background-color: var(--fully-white);
  color: var(--black);
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  transition: 0.2s;
}

.preset:hover {
  border-color: var(--tealish);
  color: var(--tealish);
}

.active {
  background-color: var(--tealish);
  border-color: var(--tealish);
  color: var(--fully-white);
}

.active:hover {
  color: var(--fully-white);
}
